/**
 * The four notice types.
 *
 * MIRRORS PHP: `render.php` holds the same map. Two runtimes, no shared
 * module — the editor needs it as an ES module and the renderer needs it
 * before any JS runs. Change one, change the other. Same posture as the
 * Social Icons service registry.
 *
 * `label` is read aloud but not shown. Type is otherwise carried by colour and
 * an icon alone, which is exactly the information a screen reader would never
 * receive and a reader with low colour vision could not separate.
 */

import { __ } from '@wordpress/i18n';

export const NOTICE_TYPES = {
  info: {
    label: __('Note:', 'brandy-blocks'),
    title: __('Info', 'brandy-blocks'),
    icon: 'info',
  },
  success: {
    label: __('Success:', 'brandy-blocks'),
    title: __('Success', 'brandy-blocks'),
    icon: 'check-circle',
  },
  warning: {
    label: __('Warning:', 'brandy-blocks'),
    title: __('Warning', 'brandy-blocks'),
    icon: 'warning',
  },
  error: {
    label: __('Error:', 'brandy-blocks'),
    title: __('Error', 'brandy-blocks'),
    icon: 'x-circle',
  },
};

export const DEFAULT_TYPE = 'info';

/**
 * The glyph for a notice, honouring an author's explicit override.
 *
 * @param {string} type     Notice type.
 * @param {string} override Author-chosen glyph name, or ''.
 * @return {string} Glyph name.
 */
export function getNoticeIcon(type, override) {
  if (override) {
    return override;
  }
  return (NOTICE_TYPES[type] || NOTICE_TYPES[DEFAULT_TYPE]).icon;
}

/**
 * @param {string} type Notice type.
 * @return {string} Screen-reader label.
 */
export function getNoticeLabel(type) {
  return (NOTICE_TYPES[type] || NOTICE_TYPES[DEFAULT_TYPE]).label;
}
